export const ONBOARDING_COMPLETED_KEY = 'onboarding_completed';

export interface OnboardingGateParams {
  hasDriverId: boolean;
  hasCompanyId: boolean;
  isFetchingUserCompanies: boolean;
  isOwner: boolean;
  companyDriversLoading: boolean;
  dispatchesLoading: boolean;
  /** Drivers other than the owner looking, who drives too. */
  otherDriversCount: number;
  dispatchesCount: number;
  onboardingCompleted: boolean;
}

/**
 * Returns true when the app should redirect to /onboarding.
 * Extracted as a pure function so it can be unit-tested independently of HomeScreen.
 */
export function shouldShowOnboarding(params: OnboardingGateParams): boolean {
  const {
    hasDriverId,
    hasCompanyId,
    isFetchingUserCompanies,
    isOwner,
    companyDriversLoading,
    dispatchesLoading,
    otherDriversCount,
    dispatchesCount,
    onboardingCompleted,
  } = params;

  if (!hasDriverId || !hasCompanyId) return false;
  if (isFetchingUserCompanies) return false;
  if (!isOwner) return false;
  if (companyDriversLoading || dispatchesLoading) return false;
  if (otherDriversCount > 0 || dispatchesCount > 0) return false;
  if (onboardingCompleted) return false;

  return true;
}
